import React from 'react';
//NavBar-Logo-Webview_390x60.png
 const HeaderComponent = () => {
    return (
        <section id="header" className="container-fluid background">
                <div className="container">
                    <div className="row header-upper flex-column flex-lg-row justify-content-center align-items-center p-3">
                        <div className="d-flex flex-column flex-lg-row align-items-center ">
                            <a href="https://smartbikemobility.com"><img height={30} src={require('../assets/images/NavBar-Logo-Webview_390x60.png')}  alt="" /></a>  
                        </div>
                    </div>
                </div>
        </section>
    )
 }

 export default HeaderComponent;
